import { HttpContextToken } from '@angular/common/http';

export const SUPPRESS_FORBIDDEN_NOTIFICATION = new HttpContextToken<boolean>(() => false);
